export const environment = {
  APP_DYNAMICS_KEY: "GR-AAB-DHH",
  API: "https://gatewayportal-hml.yamahaservicosfinanceiros.com.br/api/v1/",
  BLOB_INTERNAL_DOMAIN: "saportaldealershml.blob.core.windows.net",
  appInsights: {
    instrumentationKey: '1a58f59c-8b3b-499c-b954-781605d68996'
  },
  enableAppDynamics: false
};
